import React from "react";
import { useNavigate } from "react-router-dom";
import "./ReadyToStartBox.css";

const ReadyToStartBox = () => {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate("/login");
  };

  return (
    <div className="cta-container">
      <div className="cta-box-readytostart">
        <h2 className="cta-box-readytostart-h2">
          Ready to Build Your <br /> Personal Brand on LinkedIn?
        </h2>
        <button onClick={handleCTAClick} className="cta-button">
          <span>→ Start For Free</span>
        </button>
      </div>
    </div>
  );
};

export default ReadyToStartBox;
